<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Editar información de usuario</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="registerForm">
                    <div class="form-body">
                        <h3 class="card-title">Información personal</h3>
                        <hr>
                        <div class="row p-t-20">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Nombre</label>
                                    <input formControlName="name" type="text"  class="form-control" placeholder="Nombre">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Apellido</label>
                                    <input formControlName="surname" type="text"  class="form-control" placeholder="Apellido">
                                </div>
                            </div>
                            <div *ngIf="user.role!='evaluated'" class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Alias</label>
                                    <input formControlName="alias" type="text"  class="form-control" placeholder="Alias">
                                </div>
                            </div>
                            <!--/span-->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Email</label>
                                    <input [readOnly]="true" formControlName="email" type="email"  class="form-control" placeholder="Email">
                                </div>
                            </div>
                            <!--/span-->
                        </div>
                        <!--/row-->
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Rol</label>
                                    <select formControlName="role" class="form-control custom-select">
                                        <option value="admin">admin</option>
                                        <option value="client">client</option>
                                        <option value="evaluated">evaluated</option>
                                    </select>
                                </div>
                            </div>


                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Teléfono</label>
                                    <input formControlName="phone" type="text" class="form-control" placeholder="Teléfono">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Profesión</label>
                                    <input formControlName="profession" type="text" class="form-control" placeholder="Profesión">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Empresa</label>
                                    <input formControlName="company" type="text" class="form-control" placeholder="Empresa">
                                </div>
                            </div>
                            <div class="col-md-6">    
                                <div class="form-group">
                                    <label class="control-label">Notas</label>
                                    <input formControlName="notes" type="text" class="form-control" placeholder="Notas">
                                </div>
                            </div>
                            <div *ngIf="registerForm.value.role!='evaluated'" class="col-md-6">    
                                <div class="form-group">
                                    <label class="control-label">Cantidad de pruebas</label>
                                    <input formControlName="remainingTests" type="number" class="form-control" placeholder="Cantidad de pruebas">
                                </div>
                            </div>
                            <div *ngIf="registerForm.value.role!='evaluated'" class="col-md-6">
                                <div class="form-group">
                                    <button class="btn btn-warning waves-effect" (click)="resetRemainingDays()">Reiniciar período de validez de pruebas</button>
                                </div>

                                <span>{{user.lastPurchase | date: 'dd/MM/yyyy'}} - </span>

                                <span *ngIf="(user.daysLeft >= 370)">
                                    Ilimitado
                                </span>

                                <span *ngIf="(user.daysLeft < 370)">
                                    {{add370Days(user.lastPurchase) | date: 'dd/MM/yyyy'}}
                                </span>



                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">País</label>
                                    <input formControlName="country" type="text" class="form-control" placeholder="País">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Ciudad</label>
                                    <input formControlName="city" type="text" class="form-control" placeholder="Ciudad">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Sexo</label>
                                    <select class="form-control" formControlName="sex">
                                        <option selected value="Masculino">Masculino</option>
                                        <option value="Femenino">Femenino</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Fecha de nacimiento</label>
                                    <input formControlName="birthDate" type="date" class="form-control" placeholder="Fecha de nacimiento">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input *ngIf="registerForm.value.role!='evaluated'" [(ngModel)]="password" [ngModelOptions]="{standalone: true}" type="password" class="form-control" placeholder="Contraseña">
                                    <input *ngIf="registerForm.value.role=='evaluated'" [(ngModel)]="password" [ngModelOptions]="{standalone: true}" type="text" class="form-control" placeholder="Contraseña">
                                    <button class="btn btn-warning waves-effect" (click)="updatePassword()">Actualizar contraseña</button>
                                </div>
                            </div>
                            
                            
                        
                        </div>
                        
                    </div>
                </form>
            </div>
        </div>

        <div *ngIf="registerForm.value.role == 'client'" class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Configuración de su Plan</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="registerForm" (ngSubmit)="update()">
                    <div class="form-body">
                        <div class="row p-t-20">

                            <div class="col-md-6">    
                              <div class="form-group">
                                  <input type="checkbox" formControlName="firstBuy" id="basic_checkbox_1" checked>
                                  <label for="basic_checkbox_1">Primer compra realizada</label>
                              </div>
                            </div>
                            <div class="col-md-6">    
                              <div class="form-group">
                                  <input type="checkbox" formControlName="isCustomBrand" id="basic_checkbox_2" checked>
                                  <label for="basic_checkbox_2">Acceso a marca blanca</label>
                              </div>
                            </div>
                            
                            <div class="col-md-6">    
                                <div class="form-group">
                                    <input type="checkbox" formControlName="canUseCustomTests" id="basic_checkbox_3" checked>
                                    <label for="basic_checkbox_3">Suscripción evaluaciones</label>
                                </div>
                            </div>
                            <div class="col-md-6">    
                                <div class="form-group">
                                    <input type="checkbox" formControlName="canUseTestCreator" id="basic_checkbox_4" checked>
                                    <label for="basic_checkbox_4">Creador de evaluaciones</label>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mb-1">
                                    <label class="control-label">Dias de prueba</label>
                                    <input [(ngModel)]="demoDays" [ngModelOptions]="{standalone: true}" type="number" class="form-control" placeholder="Dias">
                                </div>
                                <span *ngIf="user.demoSubscriptionEnd">Fecha de finalización actual {{user.demoSubscriptionEnd | date: 'dd/MM/yyyy'}}</span>
                            </div>
                            <div *ngIf="registerForm.value.role != 'evaluated'" class="col-md-6">
                                <div class="form-group pt-2">
                                    <button class="btn btn-warning waves-effect mt-4" (click)="setDemoDays()">Activar prueba por dias</button>
                                </div>
                            </div>
                            <div class="col-md-6 mb-3 mt-3">    
                              <button type="button" class="btn btn-warning btn-rounded" (click)="clearBrand()" > Borrar datos de marca</button>
                            </div>
                            
                        </div>
                        
                    </div>
                </form>
            </div>
        </div>


        <div *ngIf="registerForm.value.role == 'client'" class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Plan Enterprise</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="registerForm" (ngSubmit)="update()">
                    <div class="form-body">
                        <div class="row p-t-20">
                            <div class="col-md-6">    
                              <div class="form-group">
                                  <input type="checkbox" formControlName="isEnterprise" id="enterprise" [checked]="registerForm.value.isEnterprise">
                                  <label for="enterprise">Plan Enterprise</label>
                              </div>
                            </div>
                            <div class="col-md-6">    
                              <div class="form-group">
                                  <input type="checkbox" formControlName="isUnlimited" id="unlimited" [checked]="registerForm.value.isUnlimited">
                                  <label for="unlimited">Créditos ilimitados</label>
                              </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Fecha de vencimiento</label>
                                    <input formControlName="enterpriseExpireDate" type="date" class="form-control" placeholder="Fecha de vencimiento">
                                </div>
                            </div>
                            <div class="col-md-6">    
                                <div class="form-group">
                                    <label class="control-label">Cuentas secundarias</label>
                                    <input formControlName="subaccountLimit" type="number" class="form-control" placeholder="Cantidad de subcuentas">
                                </div>
                            </div>
                        </div>
                        
                    </div>

                </form>
            </div>
        </div>

        <div class="form-actions">
            <button type="button" class="btn btn-info btn-rounded" (click)="update()"> <i class="fa fa-check"></i> Actualizar</button>
        </div>


    </div>
</div>